export default __webpack_public_path__ + "static/media/video_1280.2827331d.mp4";